import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=5f4389c7"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"
import style0 from "./Details.vue?vue&type=style&index=0&id=5f4389c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports